import styled from 'styled-components';

// light is generally used for logged out pages and extraLight is logged in pages
type Background = 'extraLight' | 'light';
type NavbarPlacement = 'side' | 'top';

export type PageContainerProps = {
  $background: Background;
  $navbarPlacement: NavbarPlacement;
  $bannersHeight?: number;
};

// This sits below banners and contains the nav bar + main content
export const PageContainer = styled.div<PageContainerProps>`
  background-color: ${({ $background }) => ($background === 'light' ? 'var(--surface-100);' : 'var(--surface-50)')};
  min-height: 100vh;
  min-height: 100dvh; //iOS safari
  display: flex;
  flex-direction: ${({ $navbarPlacement }) => ($navbarPlacement === 'top' ? 'column;' : 'row')};
`;
